export default "__VITE_ASSET__5f4e7790__"